import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';
import { BaseService } from 'src/app/core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-pos-add-deposit-dialog',
  templateUrl: './pos-add-deposit-dialog.component.html',
  styleUrls: ['./pos-add-deposit-dialog.component.scss']
})
export class PosAddDepositDialogComponent implements OnInit {
  busy: boolean = false;
  public salesOrder: any;

  storeId: number;
  containerId: number;
  equipmentTypeCode: string;
  formValid: boolean = false;
  formValue: any;

  constructor(
    public dialogRef: MatDialogRef<PosAddDepositDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {
    this.salesOrder = data;
  }


  ngOnInit() {

  }

  paymentChanged(event: {
    storeId: number;
    containerId: number;
    equipmentTypeCode: string;
    formValid: boolean;
    formValue: any;
  }) {
    this.storeId = event.storeId;
    this.containerId = event.containerId;
    this.equipmentTypeCode = event.equipmentTypeCode;
    this.formValid = event.formValid;
    this.formValue = event.formValue;
  }

  save() {
    if (this.equipmentTypeCode === 'TFGVISION') {
      const payload = {
        salesOrderNumber: this.data.erpSalesOrderNumber,
        storeId: this.storeId,
        containerId: this.containerId,
        amountPaid: this.formValue.amountTendered,
        paymentData: this.formValue
      };

      const dialogData: OiGroupDialogData = {
        title: 'Authorizing TFG Credit Card',
        function: 'portal_oi_group_payment_tfg_deposit',
        postBody: payload
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
          this.dialogRef.close(true);
        }
      });

    } else if (this.equipmentTypeCode === 'YOYO') {
      const payload = {
        salesOrderNumber: this.data.erpSalesOrderNumber,
        storeId: this.storeId,
        containerId: this.containerId,
        amountPaid: this.formValue.amountTendered,
        paymentData: this.formValue
      };

      const dialogData: OiGroupDialogData = {
        title: 'Authorizing YOYO Payment',
        function: 'portal_oi_group_payment_yoyo_deposit',
        postBody: payload
      };

      const ref = this.dialog.open(OiGroupProcessDialogComponent, {
        data: dialogData,
        width: '450px'
      });

      ref.afterClosed().subscribe(oiResult => {
        if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
          this.dialogRef.close(true);
        }
      });

    } else {
      this.busy = true;
      this.baseService.executeCommand<any>('portal_pos_payment_capture_deposit', {
        salesOrderNumber: this.data.erpSalesOrderNumber,
        storeId: this.storeId,
        containerId: this.containerId,
        amountPaid: this.formValue.amountTendered,
        paymentData: this.formValue
      }).subscribe(
        response => {
          if (response.responseCode === 0) {
            this.dialogRef.close(true);
          } else {
            this.busy = false;
          }
        },
        error => {
          this.busy = false;
        });
    }
  }

}
